/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: Ahmad Riazi (https://sketchfab.com/ahmadriazi)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/linkdin-logo-13616694f59148f082a53b8c7cba7c4c
Title: Linkdin Logo
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import useHoverGlow from "../../hooks/useHoverGlow";
import { useResponsiveValues } from "../../utils/responsiveValues";
import { config } from "../../config";

function LinkedinLogo(props) {
  const { nodes, materials } = useGLTF("/models/linkedin.glb");

  const { hovered, setHovered } = useHoverGlow(materials, "#7FFF00", 1);

  const { linkedin } = useResponsiveValues();
  return (
    <group {...props} dispose={null}>
      <group
        position={linkedin.position}
        scale={linkedin.scale}
        rotation={linkedin.rotation}
        onClick={() =>
          window.open(`${config.contact.socials[0].url}`, "_blank")
        }
        onPointerEnter={() => setHovered(true)}
        onPointerLeave={() => setHovered(false)}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_4.geometry}
          material={materials["Material.007"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_5.geometry}
          material={materials["Material.006"]}
        />
      </group>
    </group>
  );
}

export default LinkedinLogo;
useGLTF.preload("/models/linkedin.glb");
